import styled from 'styled-components';

import colors from '../../../../../styles/colors';

const ModalContainer = styled.div`
  padding: 24px;
  min-width: 400px;
  max-width: 700px;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${colors.shades.secondary8};
  margin: 0 0 24px 0;
  text-align: center;
`;

const TimeSlotsContainer = styled.div`
  max-height: 300px;
  min-height: 300px;
  overflow-y: auto;
  margin-bottom: 24px;
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 8px;
  padding: 16px;
`;

const TimeSlotRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const TimeSlotLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.shades.secondary8};
  min-width: 80px;
`;

const TimeSlotInput = styled.div`
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

const RecurringSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

const DaysContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

// ... existing code ...
const RepeatDay = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  margin-bottom: 10px;
  color: ${colors.base.beta};
  background-color: ${({ isSelected }) => (isSelected ? colors.shades.primary5 : colors.base.alpha)};
  border: 1px solid ${({ isSelected }) => (isSelected ? colors.shades.primary6 : colors.shades.gamma4)};
  align-items: center;
  padding: 14px;
  margin-right: 12px;
  font-weight: 400;
  flex: 1;
  font-size: 16px;
  line-height: 16px;
  justify-content: center;
  position: relative;
  cursor: pointer;
  
  &:hover {
    background-color: ${({ isSelected }) => (isSelected ? colors.shades.primary3 : colors.shades.gamma1)};
  }
`;

const DateInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DateInputLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.shades.secondary8};
`;

export {
  ModalContainer,
  ModalTitle,
  TimeSlotsContainer,
  TimeSlotRow,
  TimeSlotLabel,
  TimeSlotInput,
  ButtonContainer,
  RecurringSection,
  DaysContainer,
  RepeatDay,
  DateInputContainer,
  DateInputLabel,
};
